import { DatePipe } from '@angular/common';
import { EnvironmentService } from '../environment-service/environment.service';
import { SessionManagementService } from '../session-management-service/session-management.service';
import * as c3 from 'c3';
import * as d3 from 'd3';
var ChartGeneratorService = /** @class */ (function () {
    function ChartGeneratorService(environmentService, sessionManagementService) {
        this.environmentService = environmentService;
        this.sessionManagementService = sessionManagementService;
        this.pipe = new DatePipe('en-US');
        this._applicationIdRoots = [];
        this._applicationIdRoots = [
            'approvaltool',
            'connex',
            'connex.accounting.taskrunner',
            'connex.accounting',
            'connex.agencyBalance',
            'connex.operations',
            'connex.payments',
            'connex.permissions',
            'connex.reporting',
            'encirca',
            'mitt',
            'salestasks'
        ];
    }
    Object.defineProperty(ChartGeneratorService.prototype, "applicationIdRoots", {
        get: function () {
            return this._applicationIdRoots;
        },
        enumerable: true,
        configurable: true
    });
    ChartGeneratorService.prototype.formatAMPM = function (date) {
        return this.pipe.transform(date, 'hh:mm aa');
    };
    ChartGeneratorService.prototype.FormatDate = function (date) {
        var allButMinutes = this.pipe.transform(date, 'MM/dd/yyyy HH'); // HH because we want military time!
        var minutes = String(Math.floor(date.getMinutes() / 5) * 5).padStart(2, '0');
        return allButMinutes + ":" + minutes;
    };
    ChartGeneratorService.prototype.createTwoYAxisChart = function (data, elementSelector, chartName) {
        var mythis = this;
        if ($(elementSelector).html().length == 0) {
            $(elementSelector).html("Loading " + chartName + " chart...");
        }
        c3.generate({
            bindto: elementSelector,
            size: {
                height: 200
            },
            data: {
                json: data,
                keys: {
                    x: 'occurredOn',
                    value: ['errors', 'calls'],
                },
                xFormat: '%m/%d/%Y %H:%M:%S',
                type: 'area-spline',
                axes: {
                    errors: 'y2',
                    calls: 'y'
                },
            },
            color: { pattern: ['#ff6666', '#99cc00'] },
            grid: {
                y: { show: true }
            },
            axis: {
                y: {
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: chartName,
                    tick: {
                        format: d3.format("d")
                    }
                },
                y2: {
                    show: true,
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: 'Errors',
                    tick: {
                        format: d3.format("d")
                    }
                },
                x: {
                    type: 'timeseries',
                    tick: {
                        fit: false,
                        format: function (d) {
                            return mythis.formatAMPM(d);
                        }
                    }
                }
            },
            tooltip: {
                format: {
                    title: function (d) {
                        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
                    },
                    value: function (value, ratio, id) {
                        var format = d3.format(',');
                        return format(value);
                    }
                }
            }
        });
    };
    ChartGeneratorService.prototype.createChart = function (data, elementSelector, color, chartName) {
        var mythis = this;
        if ($(elementSelector).html().length == 0) {
            $(elementSelector).html("Loading " + chartName + " chart...");
        }
        ;
        var chartData = {
            bindto: elementSelector,
            size: {
                height: 200
            },
            data: {
                json: data,
                keys: {
                    x: 'occurredOn',
                    value: ['instances'],
                },
                xFormat: '%m/%d/%Y %H:%M:%S',
                type: 'area-spline',
                axes: {
                    instances: 'y2'
                },
            },
            color: { pattern: [color] },
            grid: {
                y: { show: true }
            },
            axis: {
                y: {
                    show: false,
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: chartName
                },
                y2: {
                    show: true,
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: chartName,
                    tick: {
                        format: d3.format("d")
                    }
                },
                x: {
                    type: 'timeseries',
                    tick: {
                        fit: false,
                        format: function (d) {
                            return mythis.formatAMPM(d);
                        }
                    }
                }
            },
            tooltip: {
                format: {
                    title: function (d) {
                        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
                    },
                    value: function (value, ratio, id) {
                        var format = d3.format(',');
                        return format(value);
                    }
                }
            }
        };
        console.log(chartData);
        c3.generate(chartData);
    };
    ;
    ChartGeneratorService.prototype.GetAggregatedData = function (startDate, endDate, interval, applicationIds) {
        var mythis = this;
        var url = this.environmentService.getApiRoot() + "aggregated/activity";
        console.log('Getting chart data.');
        $.ajax({
            contentType: 'application/json',
            url: url,
            type: 'POST',
            headers: {
                'telemetry-session': this.sessionManagementService.getSession(),
                'telemetry-request': this.sessionManagementService.uuidFast()
            },
            data: JSON.stringify({
                "startTime": mythis.FormatDate(startDate),
                "endTime": mythis.FormatDate(endDate),
                "interval": interval,
                "applicationIds": applicationIds
            }),
            success: function (data) {
                var browser = [];
                var web = [];
                var database = [];
                var users = [];
                for (var i = 0; i < data.length; i++) {
                    browser.push({ occurredOn: data[i]['occurredOn'], errors: data[i]['browserErrors'], calls: data[i]['browserCalls'] });
                    web.push({ occurredOn: data[i]['occurredOn'], errors: data[i]['webServiceErrors'], calls: data[i]['webServiceCalls'] });
                    database.push({ occurredOn: data[i]['occurredOn'], errors: data[i]['databaseErrors'], calls: data[i]['databaseCalls'] });
                    users.push({ occurredOn: data[i]['occurredOn'], instances: data[i]['activeUsers'] });
                }
                mythis.createChart(users, '#activeUserChart', '#99cc00', 'users');
                mythis.createTwoYAxisChart(database, '#databaseChart', 'database');
                mythis.createTwoYAxisChart(web, '#webChart', 'web service');
                mythis.createTwoYAxisChart(browser, '#browserChart', 'browser');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(errorThrown);
            },
            complete: function () {
            }
        });
    };
    return ChartGeneratorService;
}());
export { ChartGeneratorService };
